import SalesOrderLineInterface from '@/interfaces/SalesOrderLineInterface';
import * as AlertDialogPrimitive from '@radix-ui/react-alert-dialog';
import { LoaderCircle } from 'lucide-react';

interface RemovePersonalisationModalProps {
  open: boolean;
  line: SalesOrderLineInterface;
  onGoBack: () => void;
  onConfirm: (line: SalesOrderLineInterface) => void;
  isSubmitting?: boolean;
}

export default function RemovePersonalisationModal({
  open,
  line,
  onGoBack,
  onConfirm,
  isSubmitting = false,
}: RemovePersonalisationModalProps) {
  return (
    <AlertDialogPrimitive.Root open={open}>
      <AlertDialogPrimitive.Portal>
        <AlertDialogPrimitive.Overlay className="fixed inset-0 z-50 bg-black/40 backdrop-blur-[2px]" />

        <AlertDialogPrimitive.Content className="fixed left-1/2 top-1/2 z-[51] max-h-[calc(100dvh_-_32px)] w-[calc(100%_-_32px)] max-w-[540px] -translate-x-1/2 -translate-y-1/2 overflow-y-auto overscroll-contain border border-border bg-background px-[22px] py-[26px] shadow-[0_18px_50px_rgba(10,10,10,0.22)] outline-none sm:px-[38px] sm:py-[34px]">
          <header className="text-center">
            <AlertDialogPrimitive.Title className="mt-[8px] text-[28px] font-bold leading-[33px] sm:text-[32px] sm:leading-[37px]">
              Are you sure?
            </AlertDialogPrimitive.Title>
          </header>

          <div className="my-[22px] border-t border-dashed border-[#e5e5e5]" />

          <AlertDialogPrimitive.Description asChild>
            <div className="font-[Arial] font-normal text-[clamp(17px,1.5vw,18px)]">
              You are about to <span className="text-screwfix-red-tint-1 font-semibold">remove</span> the
              personalisation from these
              <b> {line.Quantity}</b> pieces.
              <div className="pt-10 text-[14px] text-slate-600 lg:text-[18px] font-normal font-[Arial]">
                You can choose the quantity and personalise it again.
              </div>
              {/* <p className="pt-5 font-light">You can choose the quantity and personalise it again.</p> */}
            </div>
          </AlertDialogPrimitive.Description>

          <div className="mt-[28px] flex gap-[12px] sm:flex-row sm:items-center sm:justify-between sm:gap-[20px]">
            <AlertDialogPrimitive.Action asChild>
              <button
                aria-busy={isSubmitting}
                className="button-screwfix-danger flex flex-1 h-[48px] w-full items-center justify-center gap-[9px] !px-[22px] [font-family:archivo_narrowbold,sans-serif] !text-[clamp(18px,calc(16px_+_0.3vw),19px)] font-bold focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-ring/35 disabled:pointer-events-none disabled:opacity-60 sm:min-w-[190px] sm:w-auto"
                disabled={isSubmitting}
                onClick={() => onConfirm(line)}
                type="button"
              >
                {isSubmitting ? <LoaderCircle aria-hidden="true" className="h-[18px] w-[18px] animate-spin" /> : null}
                {isSubmitting ? 'Loading..' : 'Remove'}
              </button>
            </AlertDialogPrimitive.Action>
            <AlertDialogPrimitive.Cancel asChild>
              <button
                className="button-screwfix-secondary flex flex-1 h-[48px] w-full items-center justify-center !px-[22px] [font-family:archivo_narrowbold,sans-serif] !text-[clamp(18px,calc(16px_+_0.3vw),19px)] font-bold focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-ring/30 disabled:pointer-events-none disabled:opacity-60 sm:min-w-[150px] sm:w-auto"
                disabled={isSubmitting}
                onClick={onGoBack}
                type="button"
              >
                Cancel
              </button>
            </AlertDialogPrimitive.Cancel>
          </div>
        </AlertDialogPrimitive.Content>
      </AlertDialogPrimitive.Portal>
    </AlertDialogPrimitive.Root>
  );
}
